import { ADD_HOTKEY, REMOVE_HOTKEY, SET_HOTKEYS } from './constants';

export const addHotkey = (hotkey) => ({
  payload: {
    hotkey,
  },
  type: ADD_HOTKEY,
});

export const removeHotkey = (hotkey) => ({
  payload: {
    hotkey,
  },
  type: REMOVE_HOTKEY,
});

export const setHotkeys = (hotkeys) => ({
  payload: {
    hotkeys,
  },
  type: SET_HOTKEYS,
});
